import React from 'react'

import { ToastContainer } from 'react-toastify';

export const Toaster = (props) => {
    return <ToastContainer {...props}/>
}
